export default __webpack_public_path__ + "static/media/Path3367.07a02478.svg";